import { ProductContext, productContextTagName } from '@/components/utils';
import { Component, defineComponent } from '@decify/cell-shopify/client';
import { productOptionSelectorChangeEvent, productOptionSelectorName, } from '../ProductOptionSelector';
import './ProductVariantSelector.scss';
export const productVariantSelectorName = 'ProductVariantSelector';
export const productVariantSelectorTagName = 'cell-component-product-variant-selector';
export const productVariantSelectorChangeEvent = 'change';
export class ProductVariantSelector extends Component {
    productVariant;
    constructor() {
        super(productVariantSelectorName);
        this.validateProps(['id', 'option1', 'option2', 'option3']);
        this.productVariant = {
            id: this.props.id,
            // Do not use `this.props` here as parsing the data attributes would cause
            // issues when comparing values later due to types possibly being different.
            // For example: The option value "1" (string) would become 1 (number).
            option1: this.dataset.option1 || null,
            option2: this.dataset.option2 || null,
            option3: this.dataset.option3 || null,
        };
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${productOptionSelectorName}.${productOptionSelectorChangeEvent}`, this.handleOptionChange);
    }
    handleOptionChange(data) {
        const { value, position } = data;
        // If an option has been clicked, that is currently selected, there is no need to update the variant.
        if (this.productVariant[`option${position}`] === value)
            return;
        // TODO: Fix this type error.
        // @ts-ignore
        const foundProductVariant = this.findProductVariantByOptions({
            ...this.productVariant,
            [`option${position}`]: value,
        });
        // TODO: Handle the case where the variant is not found.
        if (!foundProductVariant)
            return;
        this.productVariant = foundProductVariant;
        // Dispatch an event to notify other components that the product variant has changed.
        this.publish(productVariantSelectorChangeEvent, {
            selectedProductVariant: foundProductVariant,
            updatedProductOptions: data,
        });
    }
    findProductVariantByOptions(options) {
        const context = this.closest(productContextTagName);
        if (!context || !(context instanceof ProductContext)) {
            throw new Error('Product context not found');
        }
        const { variants } = context.product;
        return variants.find((variant) => variant.option1 === options.option1 &&
            variant.option2 === options.option2 &&
            variant.option3 === options.option3);
    }
}
defineComponent(productVariantSelectorTagName, ProductVariantSelector);
